import { h, Component, Fragment } from 'preact';
import cookies from '@buzzfeed/bf-utils/lib/cookies';

/**
 * Script to manage and broadcast the status of Google One Tap's moment callback.
 *
 * When the `skipped` property is set (via the
 * `__googleOneTapMomentCallback`), a custom `googleOneTapStatus` event is also dispatched on the
 * window, with the updated status in the event's `detail`.
 *
 * Components can check `window.__googleOneTapStatus.skipped` to determine if One Tap display has
 * been skipped. If the `skipped` property has not yet been set, they can listen for the
 * `googleOneTapStatus` event to be notified when the status is set.
 *
 * The moment callback fires when:
 * - You'll get isSkippedMoment() if:
 *   - The user dismissed One Tap
 *   - The browser suppressed it
 * - You'll get isNotDisplayed() if:
 *   - It was blocked entirely (e.g. iframe, wrong domain)
 * - Both mean "One Tap is done, or never showed"
 *
 * @constant
 * @type {string}
 */
const ONE_TAP_STATUS_SCRIPT = `
  window.__googleOneTapStatus = {};
  window.__googleOneTapMomentCallback = function(notification) {
    window.__googleOneTapStatus.skipped = (
      notification.isSkippedMoment() || notification.isNotDisplayed()
    );
    window.dispatchEvent(
      new CustomEvent('googleOneTapStatus', {
        detail: window.__googleOneTapStatus
      })
    );
  };
`;

class GoogleOneTap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      googleOneTapEnabled: false,
      loginUri: '',
      xsrf: '',
      redirectUrl: '',
    };
  }

  componentDidMount() {
    const blockedEditions = ['jp'];
    const blockedCountries = ['GB'];
    const geoCountry = cookies.get('bf-geo-country') || '';
    const isPreview = window.location.pathname.startsWith('/bpage-preview');
    const isBlockedEdition = blockedEditions.includes(this.props.edition);
    const isBlockedCountry = blockedCountries.includes(geoCountry);

    const shouldEnableGoogleOneTap = !isPreview && !isBlockedEdition && !isBlockedCountry;

    this.setState({ googleOneTapEnabled: shouldEnableGoogleOneTap });

    if (!shouldEnableGoogleOneTap) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    let xsrfCookie = '';
    document.cookie.split('; ').forEach((item) => {
      if (item.startsWith('_xsrf')) {
        xsrfCookie = item.split('=')[1];
        this.setState({ xsrf: xsrfCookie });
      }
    });

    if (xsrfCookie === '') {
      xsrfCookie = Math.random().toString(36).substring(2);
      document.cookie = '_xsrf=' + xsrfCookie + '; path=/';
      this.setState({ xsrf: xsrfCookie });
    }

    this.setState({
      loginUri: document.location.origin + '/auth/signin/google-one-tap',
      redirectUrl: document.location.href,
    });
  }

  // Fire the moment callback as soon as isLoggedIn goes true
  componentDidUpdate(prevProps) {
    if (
      this.props.isLoggedIn &&
      !prevProps.isLoggedIn &&
      typeof window.__googleOneTapMomentCallback === 'function'
    ) {
      window.__googleOneTapMomentCallback({
        isSkippedMoment: () => true,
        isNotDisplayed: () => true,
      });
    }
  }

  render() {
    return (
      this.state.xsrf &&
      this.state.googleOneTapEnabled && (
        <Fragment>
          <script dangerouslySetInnerHTML={{ __html: ONE_TAP_STATUS_SCRIPT }} />
          <div
            id="g_id_onload"
            data-client_id="761451303051-cptuhojsap0trrfcapamqqj860t3cshu.apps.googleusercontent.com"
            data-context="signin"
            data-login_uri={this.state.loginUri}
            data-skip_prompt_cookie="bf2-b_info"
            data-_xsrf={this.state.xsrf}
            data-itp_support="true"
            data-use_fedcm_for_prompt="true"
            data-redirect_url={this.state.redirectUrl}
            data-moment_callback="__googleOneTapMomentCallback"
          />
        </Fragment>
      )
    );
  }
}
export default GoogleOneTap;
